import {Column,Entity, CreateDateColumn, PrimaryGeneratedColumn} from "typeorm";

@Entity('sample')
export class Sample {
 
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column("text",{
        nullable:false,
        name:"headers"
    })
    headers:string;

    @Column("text",{
        nullable:false,
        name:"body"
    })
    body:string;

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;

}